import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import { NotFound } from "@effect/platform/HttpApiError";
import { Schema } from "effect";
export const MetaApi = HttpApiGroup.make("meta").add(HttpApiEndpoint.post("sealString")`/seal`.addSuccess(Schema.Struct({
    sealed: Schema.String
})).setPayload(Schema.Struct({
    unsealed: Schema.String
})).addError(NotFound));
